
import LanguageSwitcher from '@/components/LanguageSwitcher/LanguageSwitcher';
import { Link } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import BurgerMenu from '../Menu/Menu';

const Header = () => {

  const t = useTranslations('header');

  return (
    <section className="w-full max-w-[910px] mx-auto items-center px-2 md:px-0">
      <div className="flex justify-between md:items-center mt-5">
        <Link
          href="/"
          className="brand-logo h-[40px] md:h-[67px] w-[97px] md:w-[312px] border-b border-[#E5E7EB]"
        >
          <Image
            src="/images/main-logo.svg"
            width={161}
            height={55}
            alt="Book Tailor Logo"
          />
        </Link>
        <div className="h-10 md:h-[67px] w-auto md:w-[312px] border-b border-[#E5E7EB] flex md:items-center justify-end gap-2 md:gap-4" id='nav-button'>
          {/* Language Switcher - visible on all screens */}
          <LanguageSwitcher />

          {/* Mobile: Show hamburger menu */}
          <div className="block md:hidden mt-1.5">
            <BurgerMenu />
          </div>

          {/* Desktop: Show My Order link */}
          <div className="hidden md:flex items-center">
            <Link href="/my-orders" className="text-[#2B2B2B] hover:text-[#EAAC00] font-medium">
              {t('myOrders')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}


export default Header;